import React from 'react';

import { useGetJournalEventsListQuery } from '@entities/eventJournal/api/hooks';
import { changeTariff } from '@entities/tariff/lib';
import { JournalExport, JournalSortFilter } from '@features';
import { Icon, Skeleton, UiButton } from '@shared/ui';

import cls from './EventJournalHeader.module.css';
import { useEventJournalHeader } from '../../lib/hooks';

export const EventJournalHeader = ({
    canCreateCustomEvent,
    isOwner,
}: {
    canCreateCustomEvent: boolean;
    isOwner: boolean;
}) => {
    const { t, handleCreateEventBtn } = useEventJournalHeader();
    const { isPending } = useGetJournalEventsListQuery();
    if (isPending) {
        return (
            <header className={cls.header}>
                <div className={cls.rightWrapper}>
                    <Skeleton width={132} height={28} border="8px" classes={cls.CreateBtn} />
                    <Skeleton width={90} height={16} border="8px" />
                    <Skeleton width={90} height={16} border="8px" />
                </div>
            </header>
        );
    }
    return (
        <header className={cls.header}>
            {/* <div className={cls.leftWrapper}> */}
            {/*     <UiText tag="h2" variant="subHeading" weight="bold"> */}
            {/*        {t('EventJournal.Header.title')} */}
            {/*     </UiText> */}
            {/*     <UiButton */}
            {/*        startIcon={<Icon iconName="plus" height={14} width={14} />} */}
            {/*        btnText={t('EventJournal.Header.createEventBtn')} */}
            {/*        variant="text" */}
            {/*        btnColor="secondary" */}
            {/*        className={cls.CreateBtn} */}
            {/*        onClick={handleCreateEventBtn} */}
            {/*     /> */}
            {/* </div> */}

            <div className={cls.rightWrapper}>
                <UiButton
                    startIcon={<Icon iconName="plus" height={16} width={16} />}
                    btnText={t('EventJournal.Header.createEventBtn')}                    
                    className={cls.CreateBtn}
                    onClick={async () => {
                        if (!canCreateCustomEvent) {
                            await changeTariff(isOwner);
                            return;
                        }
                        await handleCreateEventBtn();
                    }}
                />
                <JournalSortFilter />
                <JournalExport />
            </div>
        </header>
    );
};
